<div class="description-producer-list">
  <div class="top-part" *ngIf="consumer">
    <div class="header">
      <label class="name" *ngIf="!isEditMode">{{ consumer?.name }}</label>
    </div>
    <label class="category">{{ consumer?.buildingType ? consumer.buildingType.name : 'Verbraucher' }}</label>
  </div>
  <p class="description" *ngIf="!isEditMode">{{ consumer?.description }}</p>
  <div class="body">
    <ul class="assets-list" *ngIf="selectedPlantType !== null">
      <li class="list" *ngFor="let producer of producers; trackBy: trackByFn">
        <button type="button" class="btn btn-white -border" (click)="select(producer)">{{ producer.unitPerformance }} {{ producer.plantType }}</button>
      </li>
    </ul>
  </div>
</div>
